import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/GlobalContext";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function VacancyJob() {
  let navigate = useNavigate();

  const {
    data,
    isLoading,
    setData,
    setIsLoading,
    fetchStatus,
    setFetchStatus,
    functions,
  } = useContext(GlobalContext);
  const { fetchData } = functions;

  const [search, setSearch] = useState("");

  const handleChangeSearch = (event) => setSearch(event.target.value);

  const handleSearch = (event) => {
    setIsLoading(true);
    event.preventDefault();
    let fetchData = async () => {
      setData(null);
      let result = await axios.get(
        "https://dev-example.sanbercloud.com/api/job-vacancy"
      );
      let data = result.data.data;
      setData(data);
      let searchdata = data.filter((res) => {
        return res.title.toLowerCase().includes(search.toLowerCase());
      });
      setData([...searchdata]);
    };
    fetchData();
    setSearch("");
    setIsLoading(false);
  };

  const [filter, setFilter] = useState({
    job_type: "",
    company_name: "",
    company_city: "",
  });
  const handleChangeFilter = (event) => {
    setFilter({ ...filter, [event.target.name]: event.target.value });
  };
  const handleChange = (event) => {
    navigate(`/job-vacancy/${event}`);
  };
  const handleFilter = (event) => {
    try {
      event.preventDefault();
      let fetchData = async () => {
        setData(null);
        await axios
          .get("https://dev-example.sanbercloud.com/api/job-vacancy")
          .then((result) => {
            let data = result.data.data;
            let filterData = data.filter((res) => {
              return (
                res.job_type
                  .toLowerCase()
                  .includes(filter.job_type.toLowerCase()) &&
                res.company_name
                  .toLowerCase()
                  .includes(filter.company_name.toLowerCase()) &&
                res.company_city
                  .toLowerCase()
                  .includes(filter.company_city.toLowerCase())
              );
            });
            if (filterData.length === 0) {
              setData([]);
            } else {
              setData(filterData);
            }
          })
          .finally(setIsLoading(false));
      };
      fetchData();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: '<a href="">Why do I have this issue?</a>',
      });
    }
  };

  useEffect(() => {
    if (fetchStatus) {
      fetchData();
      setFetchStatus(false);
    }
  }, [fetchStatus, setFetchStatus, fetchData]);

  return (
    <>
      <section className="bg-gray-200 p-5">
        <div className="container mx-auto mt-10"></div>
        <div class="mx-auto max-w-screen-sm text-center mb-8 lg:mb-16">
          <h2 class="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
            Open Vacancy Job
          </h2>
          <p class="font-light text-gray-500 lg:mb-16 sm:text-xl dark:text-gray-400">
            Explore the job that suits to you
          </p>
          <div class="flex">
            <form class="w-full">
              <button
                onClick={() => setIsLoading(true)}
                for="default-search"
                class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-gray-300"
              >
                Search
              </button>
              <div class="relative">
                <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5 text-gray-500 dark:text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    ></path>
                  </svg>
                </div>
                <input
                  type="search"
                  value={search}
                  onChange={handleChangeSearch}
                  id="default-search"
                  class="block p-4 pl-10 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search Job here..."
                  required=""
                />
                <button
                  onClick={handleSearch}
                  class="text-white absolute right-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Search
                </button>
              </div>
            </form>
            <button
              class="bg-red-600 rounded-lg text-white w-36 m-1 "
              onClick={() => setFetchStatus(true)}
            >
              Reset Data
            </button>
          </div>
          <div class="w-full justify-self-center mt-5 border-2">
            <div
              class="divide-y divide-gray-200 border-gray-200 dark:divide-gray-700 dark:border-gray-700 rounded-lg border"
              data-testid="flowbite-accordion"
            >
              <div id="accordion-collapse" data-accordion="collapse">
                <h2 id="accordion-collapse-heading-2">
                  <button
                    type="button"
                    className="flex bg-white items-center justify-between w-full p-5 font-medium text-left text-black border border-b-0 border-white focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-white dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800"
                    data-accordion-target="#accordion-collapse-body-2"
                    aria-expanded="false"
                    aria-controls="accordion-collapse-body-2"
                  >
                    Filter
                    <svg
                      data-accordion-icon
                      className="w-6 h-6 shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </h2>
                <div
                  id="accordion-collapse-body-2"
                  className="hidden border-white"
                  aria-labelledby="accordion-collapse-heading-2"
                >
                  <div className="p-5 border border-b-0 border-white dark:border-gray-700">
                    <p className="mb-2 text-gray-500 dark:text-gray-400">
                      <div
                        class="py-5 px-5 last:rounded-b-lg dark:bg-gray-900 first:rounded-t-lg"
                        data-testid="flowbite-accordion-content"
                      >
                        <form>
                          <div className="border-white">
                            <div class="mb-3 border-white">
                              <label
                                for="small-input"
                                class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                              >
                                Job Type
                              </label>
                              <input
                                placeholder="insert job_type"
                                name="job_type"
                                type="text"
                                id="small-input"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                                class="block w-full  text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500 "
                              />
                            </div>
                            <div class="mb-3">
                              <label
                                for="small-input"
                                class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                              >
                                Company Name
                              </label>
                              <input
                                placeholder="insert company name"
                                name="company_name"
                                type="text"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                                id="small-input"
                                class="block w-full  text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500"
                              />
                            </div>
                            <div class="mb-3">
                              <label
                                for="small-input"
                                class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                              >
                                Company City
                              </label>
                              <input
                                placeholder="insert company city"
                                name="company_city"
                                onChange={(e) =>
                                  setFilter({
                                    ...filter,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                                type="text"
                                id="small-input"
                                class="block w-full text-gray-900 border border-gray-300 rounded-lg bg-gray-50 sm:text-md focus:ring-blue-500"
                              />
                            </div>
                          </div>
                          <button
                            onClick={handleFilter}
                            class="w-20 p-3 text-white bg-blue-600 rounded-lg"
                          >
                            Filter
                          </button>
                        </form>
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isLoading ? (
          <span className="  text-xs font-medium text-blue-800 text-center p-0.5 leading-none rounded-full px-2 dark:bg-blue-900 dark:text-blue-200 absolute -translate-y-1/2 -translate-x-1/2 top-2/4 left-1/2">
            <div role="status">
              <svg
                aria-hidden="true"
                className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          </span>
        ) : (
          <div className="container mx-auto flex-wrap  items-center justify-center grid gap-8 mb-6 lg:mb-16 md:grid-cols-3">
            {data !== null &&
              data.map((res) => {
                return (
                  <div
                    key={res.id}
                    className="mt-10 flex  bg-white shadow-lg rounded-lg overflow-hidden items-center bg-gray-50 rounded-lg shadow sm:flex dark:bg-gray-800 dark:border-gray-700"
                  >
                    <img
                      src={`${res.company_image_url}`}
                      className="w-1/3 bg-cover bg-landscape"
                      alt="res.title"
                    />
                    <div className="w-2/3 p-4">
                      <h1 className="text-gray-900 font-bold text-xl">
                        {res.title} ({res.job_tenure})
                      </h1>
                      <small>{res.company_name} </small>
                      <p className="mt-2 text-gray-600 text-sm">
                        {res.company_city}, {res.job_type}
                      </p>
                      <div className=" item-center mt-2 text-gray-500">
                        <span>{res.created_at}</span>
                      </div>
                      <div className="flex item-center justify-start mt-3">
                        <button
                          onClick={() => handleChange(res?.id)}
                          className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                          Read more
                          <svg
                            aria-hidden="true"
                            className="w-4 h-4 ml-2 -mr-1"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        )}
      </section>
    </>
  );
}
